import { z } from 'zod';

// Restaurant schema for dropdown
export const restaurantSchema = z.object({
  _id: z.string(),
  title: z.string().optional(),
  name: z.string().optional(),
  description: z.string().optional(),
  image: z.string().optional(),
  logo: z.string().optional(),
});

export type TRestaurant = z.infer<typeof restaurantSchema>;

// Helper function to get consistent display name for restaurant
// Priority: title > name > 'Unnamed Restaurant'
export const getRestaurantDisplayName = (restaurant: TRestaurant | null | undefined): string => {
  if (!restaurant) return 'Unnamed Restaurant';
  return restaurant.name ?? restaurant.title ?? 'Unnamed Restaurant';
};

// API Response type for restaurant list (from API)
export type TRestaurantsApiResponse = {
  success: boolean;
  code: number;
  msg: string;
  serverTime?: string;
  data: {
    pageNum: number;
    pageSize: number;
    pages: number;
    total: number;
    rows: TRestaurant[];
  };
};

// Service Response type (transformed from API by useGetRestaurants)
export type TRestaurantsResponse = {
  restaurants: TRestaurant[];
  total: number;
};
